<template>
    <div class="sl-list">
        <ul v-if="state.stores.length">
            <li v-for="store in state.stores" :key="store.id" @click="showInfo(store.ID)">
                <location :store="store" />
            </li>
        </ul>

        <ul v-if="!state.stores.length && !state.loading">
            <li class="sl-no-locations">
                No locations available. <br> Trying adjusting your search distance.
            </li>
        </ul>
    </div>
</template>

<script>
import GM from '../utils/googleMaps';
import Location from './Location';

export default {

    components: {
        Location
    },
    props: ['stores', 'updateAsMoving'],

    methods: {
        showInfo (id) {
            //   bus.$emit('ui:togglelive',  false);

            const index = this.state.stores.findIndex((store) => store.ID === id);

            GM.markerInfo(this.state.stores, index);
        }
    }
};
</script>

<style scoped>
.sl-list {
  order: 2;
}
@media (min-width: 1024px) {
  .sl-list {
    order: 1;
    top: 0;
    left: 0;
    bottom: 0;
    background: #fff;
    position: absolute;
    width: 25%;
    overflow-y: scroll;
    border-top: solid 1px #eee;
    border-bottom: solid 1px #eee;
    height: 609px;
  }
}
.sl-list ul {
    margin: 0;
    padding: 0;
    list-style: none;
}
.sl-list li {
    padding: 8px;
  margin-bottom: 8px;
  border-bottom: solid 1px #ddd;
}
.sl-list li.sl-no-locations {
    background: #333;
    color: #fff;
    line-height: 20px;
}
</style>
